module.exports = __webpack_public_path__ + "img/snow.b236c5bb.png";